import React, { type FunctionComponent, useEffect, useState } from 'react'
import { CharityStatusSelect } from './CharityStatusSelect'
import { CharityNameFilter } from './CharityNameFilter'
import { charityStatusMap } from '../../../../../../lib/charity'
import { campaignStatusMap } from '../../../../../../lib/campaign'
import { SelectAppContext } from '../SelectAppContext'
import { CharityDateFilter } from './CharityDateFilter'

type Props = {
  appContext: CharityAppContext
  noteFilterValues: string[]
  onFilterChanged: (filter: CharityFilterType) => void
}

export const CharityFilter: FunctionComponent<Props> = ({ appContext, noteFilterValues, onFilterChanged }) => {
  const [filter, setFilter] = useState<CharityFilterType>({ appContext })

  useEffect(() => {
    onFilterChanged({ ...filter, appContext })
  }, [filter])

  return (
    <div className="card flex flex-col space-y-lg p-md sticky top-md">
      <h2 className="text-md">Filter</h2>

      <SelectAppContext style="select" onSelected={onFilterChanged} />

      <CharityNameFilter filter={filter} setFilter={setFilter} />

      <CharityStatusSelect
        label="Charity status"
        filterKey="status"
        options={[...Object.keys(charityStatusMap), ...noteFilterValues]}
        filter={filter}
        setFilter={setFilter}
      />

      <CharityStatusSelect
        label="Campaign status"
        filterKey="campaignStatus"
        options={[...Object.keys(campaignStatusMap), 'NONE']}
        filter={filter}
        setFilter={setFilter}
      />

      <CharityDateFilter label="Campaign start date" filterKey="startTime" filter={filter} setFilter={setFilter} />

      <CharityDateFilter label="Campaign end date" filterKey="endTime" filter={filter} setFilter={setFilter} />
    </div>
  )
}
